import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import DeviationDumbView from '../../DeviationViews/Dumbo';
import ImageIcon from '../../Icons/Image';
import { withMobileContext } from '../../Context';
import s from './PollEditPopup.scss';
var PollAnswerImage = /** @class */ (function (_super) {
    __extends(PollAnswerImage, _super);
    function PollAnswerImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PollAnswerImage.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, deviation = _a.deviation, isMobile = _a.isMobile;
        var mobileSuffix = isMobile ? '-mobile' : '';
        return (React.createElement("div", { className: classnames(s['answer-choose-pic'], deviation && s['with-image']), onClick: onClick }, deviation ? (React.createElement(DeviationDumbView, { deviation: deviation, width: parseInt(s["answer-image-size" + mobileSuffix], 10), height: parseInt(s["answer-image-size" + mobileSuffix], 10) })) : (React.createElement(ImageIcon, { className: s['answer-image-icon'] }))));
    };
    return PollAnswerImage;
}(React.Component));
export default withMobileContext(PollAnswerImage);
//# sourceMappingURL=PollAnswerImage.js.map